import { SearchResponseType } from '../types/types';
export var mapPlatformToResult = function (platform) { return ({
    name: platform.name,
    id: platform.id,
    logoUrl: platform.searchLogoUrl,
    responseType: SearchResponseType.PLATFORM,
}); };
export var mapEmployerToResult = function (employer) { return ({
    name: employer.name,
    id: employer.id,
    logoUrl: employer.logoUrl,
    responseType: SearchResponseType.EMPLOYER,
}); };
